export default {
  company: {
    preheader: 'Company',
    title: "Let's rethink\nfinance together.",
    body: '',
    bodyMobile: '',
    buttonText: 'Apply Now',
    buttonLink: '/careers',
    backgroundClassName: 'company-page-hero',
  },
  mission: {
    preheader: '',
    title: '',
    body: '',
    bodyMobile: '',
    buttonText: '',
    buttonLink: '',
    backgroundClassName: 'company-page-mission-hero',
  },
  hq: {
    preheader: '',
    title: '',
    body: '',
    bodyMobile: '',
    buttonText: '',
    buttonLink: '',
    backgroundClassName: 'company-page-hq-hero',
  },
  values: {
    preheader: '',
    title: '',
    body: '',
    bodyMobile: '',
    buttonText: '',
    buttonLink: '',
    backgroundClassName: 'company-page-values-hero',
  },
  payforward: {
    preheader: '',
    title: '',
    body: '',
    bodyMobile: '',
    buttonText: '',
    buttonLink: '',
    backgroundClassName: 'company-page-payforward-hero',
  },
  leadership: {
    preheader: 'Leadership',
    title: 'Meet our leaders',
    body:
      "Our leaders are way more than just a bunch of execs.\nThey're leading our charge - helping people make\nbetter financial decisions every day.",
    bodyMobile:
      "Our leaders are way more than just a bunch of execs. They're leading our charge - helping people make better financial decisions every day.",
    buttonText: '',
    buttonLink: '',
    backgroundClassName: 'leadership-page-hero',
  },
  careers: {
    preheader: 'Careers',
    title: 'Join our team',
    body:
      "We're building industry-changing products and tools,\nempowering people with information and changing\nthe way people think about their finances.",
    bodyMobile:
      "We're building industry-changing products and tools, empowering people with information and changing the way people think about their finances.",
    buttonText: '',
    buttonLink: '',
    backgroundClassName: 'careers-page-hero',
  },
};
